import { Routes } from "@angular/router";

export const RECRUITER_DASHBOARD_ROUTES: Routes = [
    { 
        path: 'dashboard',
        title: 'Dashboard',
        loadComponent: () => import('./recruiter-dashboard.component').then((e) => e.RecruiterDashboardComponent),
        data: {
            icon: 'dashboard',
            module: 'RECRUITER_DASHBOARD',
        },
    }      
]
